module.exports = __webpack_public_path__ + "img/spartan-sheetrock-framing-texture-03-large.7623b01d.jpg";